window._ = require('lodash');

import 'jquery-color';
import 'jquery-ui';
import 'luxon';

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    window.jQueryUI = require('jquery-ui');
    require('bootstrap');
    window.posLoginForm = require('./auth/class.pos.login.js').default;
}
catch (e) {
    console.log();
}

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.getElementById('csrf-token').getAttribute('content');

// window.Cookies = require('js-cookie');

window.luxon = require('luxon');
window.DateTime = luxon.DateTime;




